export default {"src":"/_next/static/media/document.228ac0cd.svg","height":29,"width":27};